import { render } from "./FarmerDisplay2.vue?vue&type=template&id=1d5ca9e6&scoped=true&ts=true"
import script from "./FarmerDisplay2.vue?vue&type=script&lang=ts"
export * from "./FarmerDisplay2.vue?vue&type=script&lang=ts"

import "./FarmerDisplay2.vue?vue&type=style&index=0&id=1d5ca9e6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5ca9e6"]])

export default __exports__